import { gql } from "@apollo/client";
import {
  EventPolicyCompliance,
  eventPolicyComplianceFragment,
} from "common/graphql/fragments/eventPolicyComplianceFragment";

export const doubleParkFragment = gql`
  fragment doubleParkFragment on double_parks {
    startTime: start_time
    endTime: end_time
    policyRateDetails: event_policy_compliance_records {
      ...eventPolicyComplianceFragment
    }
  }
  ${eventPolicyComplianceFragment}
`;

export interface DoublePark {
  startTime: string;
  // NULL while the double park is live — a session that hasn't ended yet has
  // no end time.
  endTime: string | null;
  policyRateDetails: EventPolicyCompliance[];
}
